import React, { useEffect, useState } from "react";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const LINKS = [
  { label: "Accueil", id: "accueil" },
  { label: "Bio", id: "bio" },
  { label: "Musique", id: "musique" },
  { label: "Clips", id: "clips" },
  { label: "Galerie", id: "galerie" },
  { label: "Concerts", id: "concerts" },
  { label: "Boutique", id: "boutique" },
  { label: "Presse", id: "presse" },
  { label: "Contact", id: "contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 z-50 w-full transition-all duration-500 ${
        scrolled ? "glass-strong py-3" : "py-5 bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 lg:px-8">
        <button
          data-testid="brand-logo"
          onClick={() => go("accueil")}
          className="wordmark font-display text-xl font-black tracking-tight sm:text-2xl"
        >
          OLI.VERO
        </button>

        <ul className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <li key={l.id}>
              <button
                data-testid={`nav-${l.id}`}
                onClick={() => go(l.id)}
                className="font-heading text-sm text-white/70 transition-colors duration-300 hover:text-white"
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>

        <button
          data-testid="nav-cta-listen"
          onClick={() => { window.dispatchEvent(new CustomEvent("oli-play", { detail: 0 })); go("musique"); }}
          className="btn-glow hidden rounded-full bg-electric px-5 py-2 font-heading text-sm font-semibold text-white lg:block"
        >
          Écouter
        </button>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button data-testid="mobile-menu-trigger" className="lg:hidden text-white" aria-label="Menu">
              <Menu size={26} />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="w-72 border-white/10 bg-[#080808] text-white">
            <div className="wordmark mb-8 mt-2 font-display text-2xl font-black">OLI.VERO</div>
            <ul className="flex flex-col gap-1">
              {LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`mobile-nav-${l.id}`}
                    onClick={() => go(l.id)}
                    className="w-full rounded-lg px-3 py-3 text-left font-heading text-base text-white/80 transition-colors hover:bg-white/5 hover:text-white"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </SheetContent>
        </Sheet>
      </nav>
    </header>
  );
};

export default Navbar;
